import { render, staticRenderFns } from "./PlexOnDeck.vue?vue&type=template&id=0a17a0c4&"
import script from "./PlexOnDeck.vue?vue&type=script&lang=js&"
export * from "./PlexOnDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports